import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAlertList, getDevices } from "app/services/devices/device";
import { BASE_URL } from "static/constants";

export const devicesApi = createApi({
  reducerPath: "devicesApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getDeviceList: builder.query({
      queryFn: () => {
        return { data: getDevices() };
      },
    }),
    getAlertList: builder.query({
      queryFn: () => {
        return { data: getAlertList() };
      },
    }),
  }),
});

export const { useGetDeviceListQuery, useGetAlertListQuery } = devicesApi;
